import { Container, ContainerItem } from '../common/container/Container'
import { getAppContainer } from './app'
import { moduleURLs } from '../config/api'
import { INDIVIDUAL_API_KEY, INDIVIDUAL_SERVICE_KEY } from '../modules/individuals'
import { IndividualProps, INDIVIDUAL_MODULE } from '../modules/individuals/container'
import { IndividualService } from '../modules/individuals/services/IndividualService'
import { IndividualApi } from '../modules/individuals/api/IndividualApi'

let container: Container

function init(p: IndividualProps) {
  const items = new Map<symbol, ContainerItem>()

  items.set(INDIVIDUAL_API_KEY, new ContainerItem({ instance: new IndividualApi() }))
  items.set(
    INDIVIDUAL_SERVICE_KEY,
    new ContainerItem({
      instance: new IndividualService({ apiKey: INDIVIDUAL_API_KEY }),
    })
  )

  container = new Container(items, p.parentContainer, p.config)
}

export function getIndividualContainer(): Container {
  if (!container) {
    init({
      parentContainer: getAppContainer(),
      config: {
        moduleFullUrl: moduleURLs[INDIVIDUAL_MODULE],
      },
    })
  }

  return container
}
